// Custom palette colours
import {createTheme} from "@mui/material"

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0, // mobile
            sm: 744, // tablet
            md: 1024, // small desktop
            lg: 1200, // desktop
            xl: 1536, // default, not specified
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 30,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    "&.Mui-disabled": {
                        background: `#F0EFED`,
                    },
                },
            },
        },
    },
    palette: {
        mode: `light`,
        common: {
            black: `#121212`,
        },
        primary: {
            main: `#E91627`, // NTUC Red
        },
        secondary: {
            main: `#B6ADA6`, // Taupe
        },
        success: {
            main: `#006400`,
        },
        error: {
            main: `#D10E1E`,
        },
        info: {
            main: `#77BED2`, // Ocean

        },
        warning: {
            main: `#ECB223`, // Sunshine
        },
        text: {
            primary: `#333333`, // Black 80
            secondary: `#666666`, // Black 60
            disabled: `#666666`, // Black 60
        },
    },
    typography: {
        h1: {
            fontFamily: `Roboto`,
            fontSize: `3rem`,
            fontWeight: 700,
            '@media (max-width:600px)': {
                fontSize: `2rem`,
            },
        },
        h2: {
            fontFamily: `Roboto`,
            fontSize: `2.2rem`,
            fontWeight: 700,
            '@media (max-width:600px)': {
                fontSize: `1.5rem`,
            },
        },
        h3: {
            fontFamily: `Roboto`,
            fontSize: `2.0rem`,
            fontWeight: 700,
            '@media (max-width:600px)': {
                fontSize: `1.2rem`,
            },
        },
        h4: {
            fontFamily: `Roboto`,
            fontSize: `1.8rem`,
            fontWeight: 700,
            '@media (max-width:600px)': {
                fontSize: `1rem`,
            },
        },
        h5: {
            fontFamily: `Roboto`,
            fontSize: `1.4rem`,
            fontWeight: 700,
            '@media (max-width:600px)': {
                fontSize: `1rem`,
            },
        },
    },
})

export default theme
